import { auth } from "@/services/firebase";
import { signOut } from "firebase/auth";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";


export const useSignOut = () => {
    const navigate = useNavigate();
  
    const signOutUser = useCallback(() => {
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          localStorage.removeItem('token');
          navigate('/login');
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Sign out error:', error);
        });
    }, [navigate]);
  
    return signOutUser;
  };
